import mainDictionary_2 from '@widgets/main_2/i18n/main_2.dic.json';

export const mainPage_2 = {
  MAIN_PAGE_2: mainDictionary_2,
};

export const mainPageNamespaces_2 = Object.keys(mainPage_2);
